import { Injectable } from '@angular/core';
import { ApiService } from '../../shared/services/core/api.service';
import { map, Observable, of, tap } from 'rxjs';
import { PreviewStore } from './preview.store';
import { Preview } from '../models/preview.model';
import { PreviewQuery } from './preview.query';

@Injectable({
  providedIn: 'root',
})
export class PreviewService {
  constructor(
    private apiService: ApiService,
    private previewStore: PreviewStore,
    private previewQuery: PreviewQuery
  ) {}
  private endPoint: string = 'preview';

  fetchPreviewScorecard(clubId: number = 1) {
    let req$ = this.apiService.get<Preview>(`${this.endPoint}/scorecards?clubId=${clubId}`).pipe(
      tap((scorecard) => this.previewStore.add(scorecard)),
      map(() => null)
    );
    return this.checkHasEntity(req$);
  }

  fetchPreviewMarketplace(lcid: number, clubId: number = 1) {
    let req$ = this.apiService.get<Preview>(`${this.endPoint}/marketplace?clubId=${clubId}&lcid=${lcid}`).pipe(
      tap((marketplace) => this.previewStore.add(marketplace)),
      map(() => null)
    );
    return this.checkHasEntity(req$);
  }

  fetchPreviewLotto(lcid: number, clubId: number = 1) {
    let req$ = this.apiService.get<Preview>(`${this.endPoint}/lottos?clubId=${clubId}&lcid=${lcid}`).pipe(
      tap((lottos) => this.previewStore.add(lottos)),
      map(() => null)
    );
    return this.checkHasEntity(req$);
  }

  fetchPreviewAuction(lcid: number, clubId: number = 1) {
    let req$ = this.apiService.get<Preview>(`${this.endPoint}/auctions?clubId=${clubId}&lcid=${lcid}`).pipe(
      tap((auctions) => this.previewStore.add(auctions)),
      map(() => null)
    );
    return this.checkHasEntity(req$);
  }

  checkHasEntity(req: Observable<any>) {
    return this.previewQuery.hasEntity() ? of(null) : req;
  }
}
